import * as yup from "yup";
import { MAX_ITEM_QTY } from "../../../constants";
import { paymentLinkStatus } from "../../../enums";

import { ICreateEditPaymentLink } from "../../../interfaces-and-types";

const txPayoutTagSchema /*: yup.SchemaOf<ICreateTxPayoutTag>*/ = yup
  .object()
  .shape({
    // temp_bank_acc_id: yup
    //   .string()
    //   .required("bank account id is required for UI tracking"),

    payout_tag: yup.string().required("Payout tag is required"),
    amount: yup
      .number()
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .nullable()
      .optional()
      // .required("Amount is required") // required if % is NULL
      .positive("Amount must be a positive number"),
    percentage: yup
      .number()
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .nullable()
      .optional()
      // .required("percentage is required") // required if % is NULL
      .positive("percentage must be a positive number"),
    app_fee_percentage: yup
      .number()
      .transform((_value, originalValue) =>
        !originalValue
          ? null
          : Number(originalValue.toString().replace(/,/g, ""))
      )
      .nullable()
      .optional(),
    description: yup.string().nullable().optional(), // Allow null or string
    metadata: yup.string().nullable().optional(), // Allow null or string
  });

export const createEditPaymentLinkSchema: yup.SchemaOf<ICreateEditPaymentLink> =
  yup
    .object({
      id: yup.string().nullable().optional(),

      payment_link_name: yup.string().nullable().optional(),
      friendly_url: yup.string().nullable().optional(),

      currency: yup.string().required("Currency is required"),
      line_items: yup
        .array()
        .of(
          yup.object().shape({
            id: yup.string().nullable().optional(),
            product: yup.string().required("product is required"),
            description: yup.string().optional(),
            qty: yup
              .number()
              .transform((_value, originalValue) =>
                !originalValue
                  ? 0
                  : Number(originalValue.toString().replace(/,/g, ""))
              )
              .positive()
              .max(MAX_ITEM_QTY, "Max quantity must be less than {0}")
              .min(
                yup.ref("min_qty"),
                "Qty must be greater than or equal to min"
              )
              .max(yup.ref("max_qty"), "Qty must be less than or equal to max")
              .required("Title is required"),
            is_qty_adjustable_by_customer: yup
              .boolean()
              .required("Title is required"),
            min_qty: yup
              .number()
              .transform((_value, originalValue) =>
                !originalValue
                  ? 0
                  : Number(originalValue.toString().replace(/,/g, ""))
              )
              .min(0)
              .required("Min qty is required"),
            max_qty: yup
              .number()
              .transform((_value, originalValue) =>
                !originalValue
                  ? 0
                  : Number(originalValue.toString().replace(/,/g, ""))
              )
              .positive()
              .max(MAX_ITEM_QTY, "Max quantity must be less than {0}")
              .required("Title is required"),
          })
        )
        .min(1, "Please add at least one product to create payment link"),
      disabled_gateways: yup.array().of(
        yup.object().shape({
          gateway_code: yup.string().required("Gateway Id is required"),
          is_enabled: yup.boolean().required("status is required"),
        })
      ),
      enable_developer_options: yup
        .boolean()
        .required("Developer options status is required"),
      live_webhook_url: yup.string().url().nullable(),
      test_webhook_url: yup.string().url().nullable(),
      status: yup
        .mixed<paymentLinkStatus>()
        .oneOf(Object.values(paymentLinkStatus))
        .required("status is required"),

      enable_instant_settlement_providers_only: yup.boolean().optional(),
      transaction_payout_tags: yup.array().of(txPayoutTagSchema).optional(),

      partial_payment_enabled: yup.boolean().optional(),
      max_partial_payment_count: yup.number().optional(),

      // social media links
      enable_social_media_links: yup
        .boolean()
        .required("Social media link status is required"),
      instagram_url: yup.string().nullable().optional(),
      facebook_url: yup.string().nullable().optional(),
      whatsapp_url: yup.string().nullable().optional(),

      is_donation_payment_link: yup
        .boolean()
        .required("Please indicate if link is a donation payment link"),
      collect_tax_automatically: yup
        .boolean()
        .required("Please indicate whether to collect tax automatically"),
      require_customer_full_name: yup
        .boolean()
        .required("Please indicate if customer full name is required"),
      require_customer_address: yup
        .boolean()
        .required("Please indicate if customer address is required"),
      require_customer_phone_number: yup
        .boolean()
        .required("Please indicate if customer phone number is required"),
      allow_promo_codes: yup
        .boolean()
        .required("Please indicate if promo codes are allowed for this link"),
      allow_business_customers_to_provide_tax_id: yup
        .boolean()
        .required("Please indicate if business customers can provide tax id"),
      save_payment_for_future_use: yup
        .boolean()
        .required("Please indicate whether to save payment for future use"),

      // temp ui helpers
      uses_payout_tag_percentage: yup
        .boolean()
        .required("Please indicate whether to use % or amount for payout tags"),
    })
    .required();
